'use strict';

var dialog = require('../../dialog'),
    productStoreInventory = require('../../storeinventory/product'),
    // tooltip = require('../../tooltip'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    availability = require('./availability'),
    // image = require('./image'),
    productNav = require('./productNav'),
    productSet = require('./productSet'),
    // recommendations = require('./recommendations'),
    variant = require('./variant'),
    tooltip = require('./tooltip'),
    bisn = require('./backinstock'),
    comingsoon = require('./comingsoon');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
    productNav();
    getFirstTrOfTable();
    // recommendations();
    // tooltip.init();
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $mainClass = $('body');

    addToCart();
    availability.init();
    variant();
    // image();
    productSet();
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $mainClass.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    $mainClass.off('click', '.js-add-to-wishlist').on('click', '.js-add-to-wishlist', function (e) {
    	var obj = $(this);
    	var $variantSelector = $('.pdpForm').find('.size-conversion-container .sizeConversion .sizeLabel, .size-conversion-container .sizeConversion.no-conversion');
        let isNoConversion = $('.pdpForm').find('.size-conversion-container .sizeConversion.no-conversion').length > 0;
    	var $colorSelector=$('.pdpForm').find('.swatch_container .swatch_label');
    	var $colorVariantCount=0;
    	$colorVariantCount=$('.pdpForm').find('.swatch_container .swatches.color .swatches__item');
    	if($variantSelector.length > 0 && $colorVariantCount.length<=1) {
    		var isVariantSelected = _isVariantSelected.call(this);
            if (!isVariantSelected) {
                e.preventDefault();
                tooltip.show(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector, Resources.WISHLIST_SELECT_VARIANT, 75);
                return false;
            } else {
                tooltip.hide(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector);
            }
    	}else if($colorSelector.length > 0 && $colorVariantCount.length > 1){
    		var isVariantSelected = _isColorSelected.call(this);
            if (!isVariantSelected) {
                e.preventDefault();
                tooltip.show($colorSelector, Resources.WISHLIST_SELECT_COLOR, 75);
                return false;
            } else {
                tooltip.hide($colorSelector);
            }
    	}
        
        if($(this).hasClass('go-to-wishlist')){
            window.location.href = Urls.wishlistshow; 
        }
        if ($('#auth').length) {
            e.preventDefault();
            var auth = $('#auth').val();
            var url = Urls.accountshow;
            if(auth == 'true') {
              $.ajax({
                  url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                  dataType: 'json'
              }).done(function (data) { 
                  if (data.success) {
                      obj.find('i')
	              	  	.removeClass('icon--wishlist-heart')
	              	  	.addClass('icon--favorite');
                      obj.find('.wishlist-btn-txt')
	              	  	.html(Resources.WHISHLIST_BUTTON)
                      obj.addClass('go-to-wishlist').off('click');
                      pushAddToWhishlistAction(data.moengageProduct);
                  }else{
                      window.alert(Resources.BAD_RESPONSE);
                  }
              });
            }else{
                window.location.href = url;
            }
        }
    });

    // product options
    $mainClass.on('change', '.product-options select', function () {
        var salesPrice = $(this).closest().find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $mainClass.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    $mainClass.on('click', '.js-size-guide-btn' ,function (e) {
        e.preventDefault();
        if($('.window-overlay').find('div.back-in-stock__dialog').length !== 0) {
            $('.window-overlay').find('div.back-in-stock__dialog').parent().parent().remove();
        }
        var $data = $(this).data('dialog');

        dialog.openWithContent({
            html: $($data.content).html(),
            modalClass: $data.modalClass
        });
    });
    bisn.init();
    
    $mainClass.on('click','.window-overlay--close' , function (e) {
        e.preventDefault();
        if($('.window-overlay').find('div.size-guide__container').length !== 0) {
            $('.window-overlay').find('div.size-guide__container').parent().parent().remove();
        }
    });
    
    $mainClass.on('click', '.apple-pay-submt-btn', function(e) {
    	e.preventDefault();
    	var $variantSelector = $(this).closest('.pdpForm').find('.js-variation-select');
    	var selectButton = $(this).closest('.pdpForm').find('#va-size.variation-select');
    	var flag=false;
    	if(selectButton.length>0 && selectButton.val().includes("size")){
    		flag=true;
    	}
    	var notifyButton = $('.pdpForm').find('.notify-me-button');
    	if(notifyButton.length > 0 && flag){
    		tooltip.show($variantSelector, Resources.SOLDOUT_SELECT_VARIANT);
    	}
    	else if(notifyButton.length > 0 && !flag){
    		tooltip.show($variantSelector, Resources.APPLEPAY_SELECT_VARIANT);
    	}
    	else
    	{
    		tooltip.show($variantSelector, Resources.APPLEPAY_SELECT_VARIANT);

    	}
        return false;
    })
    
    $mainClass.on('click', 'a.store-menu-link', function (e) {
        e.preventDefault();
        var brandNameEl = $('input[name="produc-brand-name"]');
        var url = $(this).attr('href');
        if(brandNameEl.length <= 0) {
        	window.location = url;
        	return;
        } 
        var brandName = brandNameEl.val();
        if(brandName) {
        	brandName = brandName.trim();
        	url += url.indexOf("?") === -1 ? "?" : "&";
        	window.location = url+"name="+encodeURIComponent(brandName);
        } else {
        	window.location = url;
        }
    });
    
    $(document).ready(function() {
    	var obj = $('.apple-pay-submt-btn');
    	if(obj.length > 0) {
    		var isSafari = (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1);
    		if(isSafari !== true) {
    			obj.remove();
    		}
    	}
    	
    })
    
    $mainClass.on('click', '.add-to-cart-disabled', function (e) {
    	var obj = $(this);
        var $variantSelector = obj.closest('.pdpForm').find('.size-conversion-container .sizeConversion .sizeLabel, .size-conversion-container .sizeConversion.no-conversion');
        let isNoConversion = obj.closest('.pdpForm').find('.size-conversion-container .sizeConversion.no-conversion').length > 0;
    	var $colorSelector=obj.closest('.pdpForm').find('.swatch_container .swatch_label');
    	var $colorVariantCount=0;
    	$colorVariantCount=$('.pdpForm').find('.swatch_container .swatches.color .swatches__item');
    	if($variantSelector.length > 0 && $colorVariantCount.length<=1) {
    		var isVariantSelected = _isVariantSelected.call(this);
            if (!isVariantSelected) {
                e.preventDefault();
                tooltip.show(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector, Resources.WISHLIST_SELECT_VARIANT, 75);
                return false;
            } else {
                tooltip.hide(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector);
            }
    	}else if($colorSelector.length > 0 && $colorVariantCount.length > 1){
    		var isVariantSelected = _isColorSelected.call(this);
            if (!isVariantSelected) {
                e.preventDefault();
                tooltip.show($colorSelector, Resources.WISHLIST_SELECT_COLOR, 75);
                return false;
            } else {
                tooltip.hide($colorSelector);
            }
    	}
    });
    
    $(window).click(function(e) {
    	if(e.target !== undefined) {
    		var targetEl = $(e.target);
    		if(targetEl.length >0) {
    			if(!targetEl.hasClass('notify-me-button')) {
    				tooltip.hideAll();
    			}
    		}
    	} 
    })
    
    comingsoon.init();
}

 function getFirstTrOfTable() {
    var $sizesColumn = $('.size-guide__sizes'),
        $sizesContent = $('.size-guide__content'),
        $sizesTitleContainer = $('.size-guide__title-conteiner'),
        $shoesSizes = $('[id*="--size-guide-shoes"]'),
        $tableContent = $('<tbody>'),
        $sizesTitle = $('.table--captioned caption');

    if($shoesSizes.length === 0) {

        var maxColCount = Math.max.apply(Math, $sizesContent.find('tr').map(function () {
            return $(this).find('td').length;
        }));

        if($sizesContent.length > 1){
            $sizesContent.each(function () {
                var $tableContentElement = $('<tbody>');
                $(this).find('tr').each(function () {
                    var $tdElements = $(this).find('td'),
                        $td = $tdElements.eq(0);

                    if ($tdElements.length === maxColCount) {
                        $td.removeAttr('rowspan');
                        $tableContentElement.append($('<tr>').append($td[0].outerHTML));
                        $td.remove();
                    }
                });
                $(this).find('tr:first-child th:first-child').remove();
                
                if ($tableContentElement.length > 0) {
                    $tableContentElement.find('tr:first-child td:first-child').addClass('first-td');
                    $tableContentElement.find('tr:last-child td:first-child').addClass('last-td');
                    $(this).siblings('.size-guide__sizes').append(
                        $('<table>').append($tableContentElement)
                    );
                }
            });
        } else {
            $sizesContent.find('tr').each(function () {
                var $tdElements = $(this).find('td'),
                    $td = $tdElements.eq(0);
    
                if ($tdElements.length === maxColCount) {
                    $td.removeAttr('rowspan');
                   $tableContent.append($('<tr>').append($td[0].outerHTML));
                    $td.remove();
                }
            });
            
            $sizesContent.find('tr:first-child th:first-child').remove();
    
            if ($tableContent.length > 0) {
                $tableContent.find('tr:first-child td:first-child').addClass('first-td');
                $tableContent.find('tr:last-child td:first-child').addClass('last-td');
    
                $sizesColumn.append(
                    $('<table>').append($tableContent)
                );
            }
        }
    }

}

function _initCustomScroll() {
    if (!('ns' in pageContext) && pageContext.ns !== 'product') {
        return;
    }

    $(".size-guide__content").mCustomScrollbar({
        theme: "dark",
        axis: "x",
        enable: false,
        advanced:{ 
            updateOnContentResize: true 
        }
    });
}

function _isVariantSelected() {
	var $jsVariationSelect = $('.pdpForm').find('.size-conversion-container');
	if ($jsVariationSelect.length <= 0) {
		return true;
	}
	$jsVariationSelect = $jsVariationSelect
			.find('.sizeDescription .content-items .links-item.selected')

	if ($jsVariationSelect.length > 0) {
		return true;
	} else {
		return false;
	}
}

function _isColorSelected() {
	var $jsColorSelect = $('.pdpForm').find('.swatch_container .swatches.color');
	if ($jsColorSelect.length <= 0) {
		return true;
	}
	$jsColorSelect = $jsColorSelect
			.find('.swatches__item.selected');

	if ($jsColorSelect.length > 0) {
		return true;
	} else {
		return false;
	}
}

var product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeDom();
        initializeEvents();
    }
};

module.exports = product;


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/index.js